// utils/webSourceUtils.ts
import { WebSourceFormData, WebSource } from '../types';

// Define a type for creating a new web source that doesn't include server-generated fields
type CreateWebSourceRequest = Omit<WebSource, 'id' | 'created_at' | 'status'>;

export function transformFormDataToWebSource(formData: WebSourceFormData): CreateWebSourceRequest {
    return {
        name: formData.name,
        description: formData.description,
        source_type: 'web_source',
        configuration: {
            url: formData.url,
            crawl_frequency: formData.crawl_frequency,
            sitemap_url: formData.sitemap_url,
            crawl_depth: formData.crawl_depth  // Add crawl_depth to configuration
        }
    };
}

export function transformWebSourceToFormData(source: WebSource): WebSourceFormData {
    return {
        name: source.name,
        description: source.description || '',
        url: source.configuration.url,
        crawl_frequency: source.configuration.crawl_frequency || 'daily',
        sitemap_url: source.configuration.sitemap_url || '',
        crawl_depth: source.configuration.crawl_depth || 2  // Add crawl_depth with default value
    };
}